import { GetContactQuery } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { GET_CONTACT } from '@dustin-web/microsite-data/src/graphql/product/get-contact.graphql'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { useAuth } from '@dustin-web/microsite-components/src/auth'
import { GET_CUSTOMER_NAVIGATION } from '@dustin-web/microsite-data/src/graphql/content/get-customer-navigation.graphql'
import { GetCustomerNavigationQuery } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'

export type UseAccount = typeof useAccount

export const useAccount = () => {
  const { isAuthenticated } = useAuth()

  const { data: contactQueryData, error: contactQueryError } = useGraphql<GetContactQuery>(
    GET_CONTACT,
    {
      context: {
        skip: !isAuthenticated,
      },
    }
  )

  const { data: customerNavigationData, error: customerNavigationError } =
    useGraphql<GetCustomerNavigationQuery>(GET_CUSTOMER_NAVIGATION, {
      context: {
        skip: !isAuthenticated,
      },
    })

  return {
    contactQueryError: contactQueryError,
    contactQueryData: contactQueryData,
    customerNavigationData: customerNavigationData,
    customerNavigationError: customerNavigationError,
  }
}
